'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var setupSingleHook = require('../setup_hooks').setupSingleHook;
var _a = require('../utils'), compose = _a.compose, isPlainObject = _a.isPlainObject;
var Raw = require('../raw').default;
function translateOptions(spell, options) {
    var e_1, _a, e_2, _b;
    var attributes = options.attributes, where = options.where, group = options.group, order = options.order, offset = options.offset, limit = options.limit, include = options.include, having = options.having;
    if (attributes)
        spell.$select(attributes);
    if (include) {
        if (typeof include === 'string')
            spell.$with(include);
    }
    if (where)
        spell.$where(where);
    if (group) {
        if (Array.isArray(group))
            spell.$group.apply(spell, __spreadArray([], __read(group), false));
        else
            spell.$group(group);
    }
    if (having)
        spell.$having(having);
    if (order) {
        if (typeof order === 'string' || order instanceof Raw || isPlainObject(order)) {
            spell.$order(order);
        }
        else if (Array.isArray(order) && order.length) {
            if (order.some(function (item) { return Array.isArray(item); })) {
                try {
                    // [['created_at', 'asc'], ['id', 'desc']]
                    for (var order_1 = __values(order), order_1_1 = order_1.next(); !order_1_1.done; order_1_1 = order_1.next()) {
                        var pair = order_1_1.value;
                        if (pair[0])
                            spell.$order(pair[0], pair[1] || '');
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (order_1_1 && !order_1_1.done && (_a = order_1.return)) _a.call(order_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            else if (order.some(function (item) { return /^(.+?)\s+(asc|desc)$/i.test(item); })) {
                try {
                    // ['created_at desc', 'id asc']
                    for (var order_2 = __values(order), order_2_1 = order_2.next(); !order_2_1.done; order_2_1 = order_2.next()) {
                        var pair = order_2_1.value;
                        if (pair)
                            spell.$order(pair);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (order_2_1 && !order_2_1.done && (_b = order_2.return)) _b.call(order_2);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            else if (order.length && order[0]) {
                // ['created_at', 'asc']
                spell.$order(order[0], order[1] || '');
            }
            else if (order instanceof Raw) {
                spell.$order(order);
            }
        }
    }
    if (limit)
        spell.$limit(limit);
    if (offset)
        spell.$offset(offset);
}
var setScopeToSpell = function (scope) { return function (spell) {
    translateOptions(spell, scope);
}; };
/**
 * @param {{
 *  where: Object,
 *  limit: Integer,
 *  order: String | Array,
 * }} scopes
 * @returns {Object}
 */
function mergeScope(scopes) {
    var e_3, _a;
    var merged = {};
    try {
        for (var scopes_1 = __values(scopes), scopes_1_1 = scopes_1.next(); !scopes_1_1.done; scopes_1_1 = scopes_1.next()) {
            var scope = scopes_1_1.value;
            if (scope.where) {
                merged.where = Object.assign({}, merged.where, scope.where);
            }
            if (scope.order) {
                merged.order = Object.assign({}, merged.order, scope.order);
            }
            if (scope.limit) {
                merged.limit = scope.limit;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (scopes_1_1 && !scopes_1_1.done && (_a = scopes_1.return)) _a.call(scopes_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return merged;
}
/**
 * parse scope
 * @param {Object | Function | Array<Object> } scope
 * @returns {Function} scope
 */
function parseScope(scope) {
    if (!scope)
        return null;
    if (isPlainObject(scope)) {
        return setScopeToSpell(scope);
    }
    // scope function
    if (typeof scope === 'function') {
        scope.__isFunc = true;
        return scope;
    }
    if (Array.isArray(scope)) {
        // array should not contain function
        return setScopeToSpell(mergeScope(scope));
    }
    return scope;
}
/**
 * filter query options
 * @param {Object} [options={}]
 * @returns
 */
function filterOptions(options) {
    if (options === void 0) { options = {}; }
    var order = options.order, where = options.where, limit = options.limit, group = options.group, offset = options.offset, include = options.include, attributes = options.attributes, otherOption = __rest(options, ["order", "where", "limit", "group", "offset", "include", "attributes"]);
    return otherOption;
}
// https://sequelize.org/master/class/lib/model.js~Model.html
// https://sequelize.org/master/manual/model-querying-finders.html
module.exports = function sequelize(Bone) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(Spine, _super);
            function Spine() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(Spine, "sequelize", {
                get: function () {
                    return true;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Spine, "Instance", {
                get: function () {
                    return this;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Spine, "rawAttributes", {
                get: function () {
                    return this.attributes;
                },
                enumerable: false,
                configurable: true
            });
            /**
             * add scope see https://sequelize.org/master/class/lib/model.js~Model.html#static-method-addScope
             * @deprecated scope is not recommended to use
             * @static
             * @param {string} name
             * @param {Object|Function} scope
             * @param {
             *  override: boolean
             * } options
             * @returns
             */
            Spine.addScope = function (name, scope, options) {
                if (options === void 0) { options = {}; }
                if (!scope)
                    return;
                var override = options.override;
                if (override || !this._scopes[name]) {
                    this._scopes[name] = parseScope(scope);
                }
            };
            /**
             * @deprecated scope is not recommended to use
             * @param {string} name
             * @param  {...any} args
             * @returns
             */
            Spine.scope = function (name) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                var parentName = this.name;
                var parentTable = this.table;
                var parent = this;
                var ScopeClass = /** @class */ (function (_super) {
                    __extends(ScopeClass, _super);
                    function ScopeClass() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    Object.defineProperty(ScopeClass, "synchronized", {
                        get: function () {
                            return parent.synchronized;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(ScopeClass, "table", {
                        get: function () {
                            return parentTable;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ScopeClass.name = parentName;
                    return ScopeClass;
                }(this));
                ScopeClass.setScope.apply(ScopeClass, __spreadArray([name], __read(args), false));
                return ScopeClass;
            };
            Object.defineProperty(Spine, "unscoped", {
                get: function () {
                    return this.scope();
                },
                enumerable: false,
                configurable: true
            });
            /**
             * @deprecated scope is not recommended to use
             * @static
             * @param {function|object|array} name
             */
            Spine.setScope = function (name) {
                var _a;
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                if (name && this._scopes[name]) {
                    if (this._scopes[name].__isFunc) {
                        this._scope = parseScope((_a = this._scopes[name]).call.apply(_a, __spreadArray([this], __read(args), false)));
                    }
                    else {
                        this._scope = this._scopes[name];
                    }
                }
                else {
                    var scope = parseScope(name);
                    if (scope && scope.__isFunc)
                        this._scope = parseScope(scope.call.apply(scope, __spreadArray([this], __read(args), false)));
                    else
                        this._scope = scope;
                }
            };
            Spine.init = function (attributes, opts, descriptors) {
                if (opts === void 0) { opts = {}; }
                if (descriptors === void 0) { descriptors = {}; }
                _super.init.call(this, attributes, opts, descriptors);
                // sequelize opts.getterMethods | setterMethods
                var _a = opts.getterMethods, getterMethods = _a === void 0 ? {} : _a, _b = opts.setterMethods, setterMethods = _b === void 0 ? {} : _b, defaultScope = opts.defaultScope, scopes = opts.scopes;
                var setProp = function (obj, type) { return function (result) {
                    Object.keys(obj).map(function (key) {
                        if (!result[key]) {
                            result[key] = {
                                enumerable: true,
                                configurable: true,
                            };
                        }
                        result[key][type] = obj[key];
                    });
                    return result;
                }; };
                var overrides = compose(setProp(setterMethods, 'set'), setProp(getterMethods, 'get'))({});
                Object.defineProperties(this.prototype, overrides);
                if (defaultScope) {
                    this.addScope('defaultScope', defaultScope);
                    this.setScope('defaultScope');
                }
                if (scopes) {
                    for (var key in scopes) {
                        this.addScope(key, scopes[key]);
                    }
                }
            };
            Spine.aggregate = function (name, func, options) {
                if (options === void 0) { options = {}; }
                Object.assign({ plain: true }, options);
                func = func.toLowerCase();
                if (!['count', 'average', 'minimum', 'maximum', 'sum'].includes(func)) {
                    throw new Error("unknown aggregator function ".concat(func));
                }
                var where = options.where;
                var spell = this._find(where, options)["$".concat(func)](name);
                if (options.paranoid === false)
                    return spell.unparanoid;
                return spell;
            };
            // static belongsTo() {
            //   throw new Error('unimplemented');
            // }
            Spine.belongsToMany = function () {
                throw new Error('unimplemented');
            };
            Spine.build = function (values, options) {
                if (options === void 0) { options = {}; }
                var raw = Object.assign({ raw: false, isNewRecord: true }, options).raw;
                var attributes = this.attributes;
                var instance;
                if (raw) {
                    //  ignore field and custom setters
                    instance = new this(null, options);
                    for (var name_1 in attributes) {
                        if (values.hasOwnProperty(name_1)) {
                            instance.setDataValue(name_1, values[name_1]);
                        }
                    }
                }
                else {
                    instance = new this(values, options);
                }
                return instance;
            };
            /**
             * see https://github.com/sequelize/sequelize/blob/a729c4df41fa3a58fbecaf879265d2fb73d80e5f/src/model.js#L2299
             * @param {Array<Object>} valueSets
             * @param {Object} options
             * @returns
             */
            Spine.bulkBuild = function (valueSets, options) {
                var _this = this;
                if (options === void 0) { options = {}; }
                if (!valueSets.length)
                    return [];
                return valueSets.map(function (value) { return _this.build(value, options); });
            };
            // EXISTS
            // static bulkCreate() {}
            Spine.count = function (options) {
                if (options === void 0) { options = {}; }
                if (typeof options === 'string')
                    return _super.find.call(this).$count(options);
                var where = options.where, col = options.col, group = options.group, paranoid = options.paranoid;
                var spell = _super.find.call(this, where, filterOptions(options));
                if (Array.isArray(group))
                    spell.$group.apply(spell, __spreadArray([], __read(group), false));
                if (paranoid === false)
                    spell = spell.unparanoid;
                return spell.$count(col);
            };
            // EXISTS
            // static async create(props) {}
            Spine.decrement = function (fields, options) {
                var e_4, _a;
                var where = options.where, paranoid = options.paranoid;
                var spell = _super.update.call(this, where, {}, options);
                if (Array.isArray(fields)) {
                    try {
                        for (var fields_1 = __values(fields), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()) {
                            var field = fields_1_1.value;
                            spell.$decrement(field);
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (fields_1_1 && !fields_1_1.done && (_a = fields_1.return)) _a.call(fields_1);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
                else if (fields != null && typeof fields === 'object') {
                    for (var field in fields)
                        spell.$decrement(field, fields[field]);
                }
                else if (typeof fields === 'string') {
                    spell.$decrement(fields);
                }
                else {
                    throw new Error("Unexpected fields: ".concat(fields));
                }
                if (paranoid === false)
                    return spell.unparanoid;
                return spell;
            };
            // EXISTS
            // static async describe() {}
            Spine.destroy = function (options) {
                if (options === void 0) { options = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var where, individualHooks, paranoid, findSpell, instances;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                where = options.where, individualHooks = options.individualHooks, paranoid = options.paranoid;
                                if (!individualHooks) return [3 /*break*/, 4];
                                findSpell = this._find(where, filterOptions(options));
                                if (paranoid === false)
                                    findSpell = findSpell.unparanoid;
                                return [4 /*yield*/, findSpell];
                            case 1:
                                instances = _a.sent();
                                if (!instances.length) return [3 /*break*/, 3];
                                return [4 /*yield*/, Promise.all(instances.map(function (instance) { return instance.destroy(options); }))];
                            case 2: return [2 /*return*/, _a.sent()];
                            case 3: return [3 /*break*/, 6];
                            case 4: return [4 /*yield*/, this.bulkDestroy(options)];
                            case 5: return [2 /*return*/, _a.sent()];
                            case 6: return [2 /*return*/];
                        }
                    });
                });
            };
            // proxy to class.destroy({ individualHooks=false }) see https://github.com/sequelize/sequelize/blob/4063c2ab627ad57919d5b45cc7755f077a69fa5e/lib/model.js#L2895  before(after)BulkDestroy
            Spine.bulkDestroy = function (options) {
                if (options === void 0) { options = {}; }
                var where = options.where, force = options.force;
                var spell = this._remove(where || {}, force, __assign({}, options));
                var transOptions = __assign({}, options);
                delete transOptions.where;
                translateOptions(spell, transOptions);
                return spell;
            };
            // EXISTS
            // static drop() {}
            Spine.findAll = function (options) {
                if (options === void 0) { options = {}; }
                var spell = this._find({}, filterOptions(options));
                translateOptions(spell, options);
                if (options.paranoid === false)
                    return spell.unparanoid;
                return spell;
            };
            Spine.find = function (options) {
                if (options === void 0) { options = {}; }
                return this.findOne(options);
            };
            Spine.findAndCountAll = function (options) {
                if (options === void 0) { options = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var spell, spellCount, _a, rows, count;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                spell = this._find({}, filterOptions(options));
                                translateOptions(spell, options);
                                spellCount = this._find({}, filterOptions(options));
                                delete options.attributes;
                                translateOptions(spellCount, options);
                                delete spellCount.rowCount;
                                delete spellCount.skip;
                                if (options.paranoid === false) {
                                    spell = spell.unparanoid;
                                    spellCount = spellCount.unparanoid;
                                }
                                return [4 /*yield*/, Promise.all([spell, spellCount.count()])];
                            case 1:
                                _a = __read.apply(void 0, [_b.sent(), 2]), rows = _a[0], count = _a[1];
                                return [2 /*return*/, { rows: rows, count: count }];
                        }
                    });
                });
            };
            Spine.findByPk = function (value, options) {
                var _a;
                if (options === void 0) { options = {}; }
                var spell = _super.findOne.call(this, (_a = {}, _a[this.primaryKey] = value, _a), options);
                translateOptions(spell, options);
                if (options.paranoid === false)
                    spell = spell.unparanoid;
                return spell;
            };
            Spine.findCreateFind = function (options) {
                if (options === void 0) { options = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var where, defaults, instance, err_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                where = options.where, defaults = options.defaults;
                                return [4 /*yield*/, this.findOne(options)];
                            case 1:
                                instance = _a.sent();
                                if (!!instance) return [3 /*break*/, 6];
                                _a.label = 2;
                            case 2:
                                _a.trys.push([2, 4, , 6]);
                                return [4 /*yield*/, this.create(__assign(__assign({}, defaults), where), options)];
                            case 3:
                                instance = _a.sent();
                                return [3 /*break*/, 6];
                            case 4:
                                err_1 = _a.sent();
                                return [4 /*yield*/, this.findOne(options)];
                            case 5:
                                instance = _a.sent();
                                return [3 /*break*/, 6];
                            case 6: return [2 /*return*/, instance];
                        }
                    });
                });
            };
            Spine.findOne = function (options) {
                // findOne(null)
                if (arguments.length > 0 && options == null)
                    return null;
                var spell;
                // findOne(id)
                if (typeof options !== 'object') {
                    spell = _super.findOne.call(this, options);
                }
                else {
                    // findOne({ where })
                    // findOne()
                    // findAll maybe override by developer, that will make it return a non-Spell object
                    spell = this._find({}, filterOptions(options));
                    translateOptions(spell, __assign(__assign({}, options), { limit: 1 }));
                    spell = spell.later(function (result) { return result[0] != null ? result[0] : null; });
                }
                if (options && options.paranoid === false)
                    return spell.unparanoid;
                return spell;
            };
            Spine.findOrBuild = function (options) {
                if (options === void 0) { options = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var where, defaults, validate, instance, result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                where = options.where, defaults = options.defaults, validate = options.validate;
                                return [4 /*yield*/, this.findOne(options)];
                            case 1:
                                instance = _a.sent();
                                result = instance || this.build(__assign(__assign({}, defaults), where), { validate: validate });
                                return [2 /*return*/, [result, !instance]];
                        }
                    });
                });
            };
            Spine.findOrCreate = function (options) {
                return __awaiter(this, void 0, void 0, function () {
                    var _a, result, built;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, this.findOrBuild(options)];
                            case 1:
                                _a = __read.apply(void 0, [_b.sent(), 2]), result = _a[0], built = _a[1];
                                if (!built) return [3 /*break*/, 3];
                                return [4 /*yield*/, result.save()];
                            case 2:
                                _b.sent();
                                _b.label = 3;
                            case 3: return [2 /*return*/, [result, built]];
                        }
                    });
                });
            };
            Spine.getTableName = function () {
                return this.table;
            };
            // BREAKING
            // static hasMany() {}
            // BREAKING
            // static hasOne() {}
            Spine.increment = function (fields, options) {
                var e_5, _a;
                if (options === void 0) { options = {}; }
                var where = options.where, paranoid = options.paranoid;
                // pass options to update
                var spell = _super.update.call(this, where, undefined, options);
                if (Array.isArray(fields)) {
                    try {
                        for (var fields_2 = __values(fields), fields_2_1 = fields_2.next(); !fields_2_1.done; fields_2_1 = fields_2.next()) {
                            var field = fields_2_1.value;
                            spell.$increment(field, undefined, options);
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (fields_2_1 && !fields_2_1.done && (_a = fields_2.return)) _a.call(fields_2);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                }
                else if (fields != null && typeof fields === 'object') {
                    for (var field in fields)
                        spell.$increment(field, fields[field], options);
                }
                else if (typeof fields === 'string') {
                    spell.$increment(fields, undefined, options);
                }
                else {
                    throw new Error("Unexpected fields: ".concat(fields));
                }
                if (paranoid === false)
                    return spell.unparanoid;
                return spell;
            };
            Spine.max = function (attribute, options) {
                if (options === void 0) { options = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var spell;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                spell = _super._find.call(this, options.where, filterOptions(options)).$maximum(attribute);
                                if (options.paranoid === false)
                                    spell = spell.unparanoid;
                                return [4 /*yield*/, spell];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            Spine.min = function (attribute, options) {
                if (options === void 0) { options = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var spell;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                spell = _super._find.call(this, options.where, filterOptions(options)).$minimum(attribute);
                                if (options.paranoid === false)
                                    spell = spell.unparanoid;
                                return [4 /*yield*/, spell];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            Spine.removeAttribute = function (name) {
                var _a = this, attributes = _a.attributes, attributeMap = _a.attributeMap;
                var columnInfo = attributes[name];
                delete attributes[name];
                delete attributeMap[columnInfo.columnName];
            };
            Spine.restore = function (options) {
                if (options === void 0) { options = {}; }
                return _super.restore.call(this, options.where || {}, options);
            };
            Spine.schema = function () {
                throw new Error('unimplemented');
            };
            Spine.sum = function (attribute, options) {
                if (options === void 0) { options = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var spell;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                spell = _super.find.call(this, options.where, filterOptions(options)).$sum(attribute);
                                if (options.paranoid === false)
                                    spell = spell.unparanoid;
                                return [4 /*yield*/, spell];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            // EXISTS
            // static async sync() {}
            // EXISTS
            // static async truncate() {}
            Spine.update = function (values, options) {
                if (options === void 0) { options = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var where, paranoid, individualHooks, findSpell, instances;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                where = options.where, paranoid = options.paranoid, individualHooks = options.individualHooks;
                                if (!individualHooks) return [3 /*break*/, 4];
                                findSpell = this._find(where, options);
                                translateOptions(findSpell, options);
                                if (paranoid === false)
                                    findSpell = findSpell.unparanoid;
                                return [4 /*yield*/, findSpell];
                            case 1:
                                instances = _a.sent();
                                if (!instances.length) return [3 /*break*/, 3];
                                return [4 /*yield*/, Promise.all(instances.map(function (instance) { return instance.update(values, options); }))];
                            case 2: return [2 /*return*/, _a.sent()];
                            case 3: return [3 /*break*/, 5];
                            case 4: return [2 /*return*/, this.bulkUpdate(values, options)];
                            case 5: return [2 /*return*/];
                        }
                    });
                });
            };
            // proxy to class.update({ individualHooks=false }) see https://github.com/sequelize/sequelize/blob/4063c2ab627ad57919d5b45cc7755f077a69fa5e/lib/model.js#L3083  before(after)BulkUpdate
            Spine.bulkUpdate = function (values, options) {
                if (options === void 0) { options = {}; }
                var where = options.where, _a = options.paranoid, paranoid = _a === void 0 ? false : _a, validate = options.validate;
                var whereConditions = where || {};
                var spell = _super.update.call(this, whereConditions, values, __assign({ validate: validate, hooks: false }, options));
                var transOptions = __assign({}, options);
                delete transOptions.where;
                translateOptions(spell, transOptions);
                if (!paranoid)
                    return spell.unparanoid;
                return spell;
            };
            // EXISTS
            // static upsert(values, options)
            // EXISTS
            // get isNewRecord() {}
            Spine.prototype.update = function (values, options) {
                if (values === void 0) { values = {}; }
                if (options === void 0) { options = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var _a, fields, changeValues, originalValues, name_2, changedKeys, changedKeys_1, changedKeys_1_1, name_3, changes, res, err_2;
                    var e_6, _b;
                    var _this = this;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _a = options.fields, fields = _a === void 0 ? [] : _a;
                                changeValues = {};
                                originalValues = Object.assign({}, this.getRaw());
                                for (name_2 in values) {
                                    if (values[name_2] !== undefined && this.hasAttribute(name_2) && (!fields.length || fields.includes(name_2))) {
                                        // exec custom setters in case it exist
                                        this[name_2] = values[name_2];
                                        changeValues[name_2] = this.attribute(name_2);
                                    }
                                }
                                changedKeys = this.changed();
                                if (changedKeys) {
                                    try {
                                        for (changedKeys_1 = __values(changedKeys), changedKeys_1_1 = changedKeys_1.next(); !changedKeys_1_1.done; changedKeys_1_1 = changedKeys_1.next()) {
                                            name_3 = changedKeys_1_1.value;
                                            // custom getter should be executed in case there is a custom setter
                                            if (!(name_3 in changeValues))
                                                changeValues[name_3] = this[name_3];
                                        }
                                    }
                                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                                    finally {
                                        try {
                                            if (changedKeys_1_1 && !changedKeys_1_1.done && (_b = changedKeys_1.return)) _b.call(changedKeys_1);
                                        }
                                        finally { if (e_6) throw e_6.error; }
                                    }
                                }
                                changes = {};
                                if (fields && fields.length) {
                                    fields.map(function (key) {
                                        if (changeValues[key] !== undefined)
                                            changes[key] = changeValues[key];
                                        else if (values[key] !== undefined)
                                            changes[key] = values[key];
                                        else
                                            changes[key] = _this.attribute(key);
                                    });
                                }
                                else {
                                    changes = __assign(__assign({}, values), changeValues);
                                }
                                // instance update don't need to be paranoid
                                options.paranoid = false;
                                _c.label = 1;
                            case 1:
                                _c.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, _super.prototype._update.call(this, changes, options)];
                            case 2:
                                res = _c.sent();
                                return [2 /*return*/, res];
                            case 3:
                                err_2 = _c.sent();
                                // revert value in case update failed
                                this._setRaw(originalValues);
                                throw err_2;
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            };
            // EXISTS
            // get isNewRecord() {}
            Spine.prototype.decrement = function (fields, options) {
                var e_7, _a, _b;
                if (options === void 0) { options = {}; }
                var Model = this.constructor;
                var primaryKey = Model.primaryKey;
                if (this[primaryKey] == null) {
                    throw new Error("Unset primary key ".concat(primaryKey));
                }
                // validate
                if (options.validate !== false) {
                    var updateValues = {};
                    if (Array.isArray(fields)) {
                        try {
                            for (var fields_3 = __values(fields), fields_3_1 = fields_3.next(); !fields_3_1.done; fields_3_1 = fields_3.next()) {
                                var field = fields_3_1.value;
                                var value = this[field];
                                if (value != null)
                                    updateValues[field] = value - 1;
                            }
                        }
                        catch (e_7_1) { e_7 = { error: e_7_1 }; }
                        finally {
                            try {
                                if (fields_3_1 && !fields_3_1.done && (_a = fields_3.return)) _a.call(fields_3);
                            }
                            finally { if (e_7) throw e_7.error; }
                        }
                    }
                    else if (fields != null && typeof fields === 'object') {
                        for (var field in fields) {
                            var value = this[field];
                            if (value != null)
                                updateValues[field] = value - Number(fields[field]);
                        }
                    }
                    else if (typeof fields === 'string') {
                        var value = this[fields];
                        if (value != null)
                            updateValues[fields] = value - 1;
                    }
                    else {
                        throw new Error("Unexpected fields: ".concat(fields));
                    }
                    this._validateAttributes(updateValues);
                }
                return Model.decrement(fields, __assign(__assign({}, options), { where: (_b = {}, _b[primaryKey] = this[primaryKey], _b) }));
            };
            /**
             *
             *
             * @param {*} [options={}]
             * @returns
             */
            Spine.prototype.destroy = function (options) {
                if (options === void 0) { options = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var removeResult;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this._remove(options.force, __assign({}, options))];
                            case 1:
                                removeResult = _a.sent();
                                if (options.force)
                                    return [2 /*return*/, removeResult];
                                return [2 /*return*/, this];
                        }
                    });
                });
            };
            Spine.prototype.equals = function () {
                throw new Error('unimplemented');
            };
            Spine.prototype.equalsOneOf = function () {
                throw new Error('unimplemented');
            };
            Spine.prototype.get = function (key) {
                if (key)
                    return this[key];
                return this.toObject();
            };
            Spine.prototype.getDataValue = function (key) {
                // unset value should not throw error in sequelize
                return this.getRaw(key);
            };
            Object.defineProperty(Spine.prototype, "dataValues", {
                get: function () {
                    return this.getRaw();
                },
                enumerable: false,
                configurable: true
            });
            Spine.prototype.increment = function (fields, options) {
                var e_8, _a, _b;
                if (options === void 0) { options = {}; }
                var Model = this.constructor;
                var primaryKey = Model.primaryKey;
                if (this[primaryKey] == null) {
                    throw new Error("Unset primary key ".concat(primaryKey));
                }
                // validate instance only
                if (options.validate !== false) {
                    var updateValues = {};
                    if (Array.isArray(fields)) {
                        try {
                            for (var fields_4 = __values(fields), fields_4_1 = fields_4.next(); !fields_4_1.done; fields_4_1 = fields_4.next()) {
                                var field = fields_4_1.value;
                                var value = this[field];
                                if (value != null)
                                    updateValues[field] = value + 1;
                            }
                        }
                        catch (e_8_1) { e_8 = { error: e_8_1 }; }
                        finally {
                            try {
                                if (fields_4_1 && !fields_4_1.done && (_a = fields_4.return)) _a.call(fields_4);
                            }
                            finally { if (e_8) throw e_8.error; }
                        }
                    }
                    else if (fields != null && typeof fields === 'object') {
                        for (var field in fields) {
                            var value = this[field];
                            if (value != null)
                                updateValues[field] = value + Number(fields[field]);
                        }
                    }
                    else if (typeof fields === 'string') {
                        var value = this[fields];
                        if (value != null)
                            updateValues[fields] = value + 1;
                    }
                    else {
                        throw new Error("Unexpected fields: ".concat(fields));
                    }
                    this._validateAttributes(updateValues);
                }
                return Model.increment(fields, __assign(__assign({}, options), { where: (_b = {}, _b[primaryKey] = this[primaryKey], _b) }));
            };
            Spine.prototype.isSoftDeleted = function () {
                var deletedAt = this.constructor.timestamps.deletedAt;
                return this[deletedAt] != null;
            };
            Spine.prototype.previous = function (key) {
                var e_9, _a;
                if (key != null)
                    return this.getRawPrevious(key);
                var result = {};
                try {
                    for (var _b = __values(Object.keys(this.constructor.attributes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var attrKey = _c.value;
                        var prevValue = this.getRawPrevious(attrKey);
                        if (prevValue !== undefined)
                            result[attrKey] = prevValue;
                    }
                }
                catch (e_9_1) { e_9 = { error: e_9_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_9) throw e_9.error; }
                }
                return result;
            };
            // EXISTS
            // async reload() {}
            // EXISTS
            // restore() {}
            // EXISTS
            // async save() {}
            Spine.prototype.set = function (key, value) {
                this[key] = value;
            };
            Spine.prototype.setDataValue = function (key, value) {
                if (this.hasAttribute(key))
                    this.attribute(key, value);
                else
                    this[key] = value;
            };
            // EXISTS
            // async update() {}
            // EXISTS
            // validate() {}
            Spine.prototype.where = function () {
                var _a;
                var primaryKey = this.constructor.primaryKey;
                return _a = {}, _a[primaryKey] = this[primaryKey], _a;
            };
            Object.defineProperty(Spine.prototype, "Model", {
                /**
                 * An alias of instance constructor. Some legacy code access model name from instance with `this.Model.name`.
                 */
                get: function () {
                    return this.constructor;
                },
                enumerable: false,
                configurable: true
            });
            /**
             *
             *
             * @static
             * @param {*} hookName before/after create|destroy|upsert|remove|update
             * @param {*} fnNameOrFun function name or function
             * @param {*} func hook function
             */
            Spine.addHook = function (hookName, fnNameOrFun, func) {
                if (!hookName || (!fnNameOrFun && !func))
                    return;
                setupSingleHook(this, hookName, typeof fnNameOrFun === 'function' ? fnNameOrFun : func);
            };
            Spine.removeHook = function () {
                throw new Error('unimplemented');
            };
            return Spine;
        }(Bone)),
        /*
         * @protect
         * store all configured scopes
         */
        _a._scopes = {},
        // scope
        _a._scope = null,
        _a;
};
//# sourceMappingURL=sequelize.js.map